// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import moment from 'moment'
import store from "./store";
import './assets/css/public.css';
import './utils/validate'
import './assets/icons' // icon
import $ from "jquery";
import router from './router'
import * as echarts from 'echarts'
import axios from "axios";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import scroll from 'vue-seamless-scroll'
import 'echarts-gl'
import less from 'less'
import "amfe-flexible"
import Vant from 'vant';
import 'vant/lib/index.css';
import wx from "weixin-js-sdk"
import 'vue2-toast/lib/toast.css';
// <!-- import Toast from 'vue2-toast'; -->

import { Toast } from 'vant';
import VueWechatTitle from 'vue-wechat-title'
Vue.use(Toast);
Vue.use(VueWechatTitle)
// 挂在vue的原型上方便使用
Vue.prototype.$wx = wx;
Vue.use(Vant);
//引入通用下载方法
import { download, download1 } from './utils/request'
import { numfix } from "./utils/ruoyi";
Vue.use(scroll)
Vue.use(less)
// Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
// Vue.component('Table', () => import('./components/ElTable/tableBig.vue')) //自定义大表格
// Vue.component('confirm', () => import('./components/delate/DelateTip')) //自定义table
// Vue.component('EL-Title', () => import('./components/rightTitle/Index')) //自定义小标
// Vue.component('BarChart', () => import('./components/echarts/index')) //自定义小标
// Vue.component('El-Dialog', () => import('./components/ElDialog/Index')) //自定义弹框
// Vue.component('El-Form', () => import('./components/ElForm/Index')) //自定义左右表单
// Vue.component('El-Table', () => import('./components/ElTable/table.vue')) //自定义表格
// Vue.component('Dialog-Form', () => import('./components/ElForm/DialogForm.vue')) //自定义弹框表单
// Vue.component('Edit-Form', () => import('./components/ElForm/EditForm.vue')) //自定义编辑表单
// Vue.component('switchEcharts', () => import('./components/echarts/switchEcharts')) //开关图
// Vue.component('LineChart', () => import('./components/echarts/LineChart')) //折线图
// Vue.component('NoAreaLine', () => import('./components/echarts/NoareaLine')) //没阴影折线图
// Vue.component('Flex-Dialog', () => import('./components/ElDialog/WupaoMore.vue'))  //任意弹框
Vue.prototype.$ = $;
Vue.prototype.$axios = axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.$download = download;
Vue.prototype.$download1 = download1;
Vue.prototype.numfix = numfix
Vue.prototype.$moment = moment
Vue.prototype.$bus = new Vue(); //消息公交车
// axios.get("static/config.json", { headers: { "Cache-Control": "no-cache" } }).then((result) => {
//   //存到localStorage里面，方便在其他页面获取
localStorage.setItem('picURL', process.env.VUE_APP_PIC_API);
//   localStorage.setItem('ApiUrl', result.data.ApiUrl);
//   localStorage.setItem('picURL', result.data.picURL);
//   localStorage.setItem('webSocket', result.data.webSocket);
//   //也可以声明成全局变量,在其他页面用this.ApiUrl获取
//   //  Vue.prototype.ApiUrl=result.data.ApiUrl
// }).catch((error) => { console.log(error) });

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // store,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js